import React, {useEffect} from "react";
import {Form, Select} from "antd";

const ClassStylesEditor = props => {
    const {
        state,
        categories,
        updateEditClass,
        updateStylesCallback,
        updateCallback,
        updateWorkspace
    } = props;

    const editCategory = state.edit.class;
    const currentCategory = categories[editCategory];
    const EditorComponent = currentCategory ? currentCategory.editor : null;

    const componentProps = {
        editCategory,
        variant: currentCategory?.variant || null,
        updateStylesCallback: (newStyles) => updateStylesCallback(newStyles),
        updateWorkspace,
        updateCallback
    };

    useEffect(() => {
        const {highlightClass} = state.edit;
        if (!highlightClass) return;

        const targetRow = document.querySelector(`[data-editor-for="${highlightClass}"]`);
        const sidebarContainer = document.querySelector('.ch-nav-r-inner');

        if (targetRow && sidebarContainer) {
            const relativeTop = targetRow.getBoundingClientRect().top -
                sidebarContainer.getBoundingClientRect().top +
                sidebarContainer.scrollTop;

            sidebarContainer.scrollTo({
                top: relativeTop - 60,
                behavior: 'smooth'
            });
            targetRow.classList.remove('ch-s_ed-option-highlight');

            void targetRow.offsetWidth;
            targetRow.classList.add('ch-s_ed-option-highlight');
        }
    }, [state.edit.highlightClass, state.edit.highlightTimestamp]);

    const handleUpdateEditClass = (newCategory) => {
        const targetId = `preview-section-${newCategory}`;
        const element = document.getElementById(targetId);

        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        updateEditClass(newCategory);
    }

    return (
        <Form layout="vertical">
            {Object.entries(categories).length > 0 && (
                <Form.Item>
                    <Select
                        className="margin-b--m"
                        onChange={handleUpdateEditClass}
                        value={editCategory}
                        showSearch
                        style={{width: '100%'}}
                    >
                        {Object.entries(categories).map(([key, config]) => (
                            <Select.Option key={key} value={key}>
                                {config.title}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            )}
            {EditorComponent && (
                <div className="ch-s_ed-options">
                    <EditorComponent {...componentProps} />
                </div>
            )}
        </Form>
    )
}

export default ClassStylesEditor;